module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv10-ab1f41fe3ccd5bd5022d983b31d2360c.jpg";